// Move thumbnails into src/assets/ and adjust imports below.
import owasp from '../assets/owasp.png';
import engine from '../assets/engine.png';
import redsecret from '../assets/redsecret.png';
import tardis from '../assets/tardis.png';
import geotrade from '../assets/geotrade.png';
import trellux from '../assets/trellux.gif';
import bytepilote from '../assets/bytepilote.png';
import anna from '../assets/anna.png';
import radar from '../assets/radar.gif';
import graphy from '../assets/graphy.png'
import alice from '../assets/alice.png'
import eliza from '../assets/eliza.png'

const projects = [
  { title: 'OWASP Juice Shop', year: '2026',
    desc: 'Nationwide pentest academic project, all Epitech campuses against each other in teams of three. Rushed into the top 15 solo, scoring 36,300 points across SQLi, fuzzing, XSS, steganography and Burp-driven exploitation.',
    tags: ['SQL Injection','Fuzzing','XSS','Burp Suite','Stegano','Typosquatting'],
    badges: ['Top 15 Nationwide 🥇'],
    types: ['cybersecurity'], image: owasp, link: 'https://owasp.org/www-project-juice-shop/' },
  
  { title: 'My_engine_CPP', year: '2025',
    desc: 'A C++ graphics engine built on raw OpenGL — windowing through GLFW, GLEW for extension loading, GLM for math. A playground for understanding shaders, buffers, and the GPU pipeline at the lowest level the platform allows.',
    tags: ['C++','OpenGL','GLFW','GLEW','GLM'],
    types: ['low-level','gamedev'], image: engine, link: 'https://github.com/raph-bl/my_engine_cpp' },
  
  { title: 'RedSecret · Escape From Sverdlovsk', year: '2018 — 2022',
    desc: 'Started at 15, shipped at 18. A Minecraft mod and server inspired by Escape From Tarkov — custom 3D-modeled weapons, mechanics and a launcher. 300+ in Discord, 100 concurrent at launch. My first lesson in shipping software that other people actually use.',
    tags: ['Modding','Java','Team Leadership','3D Modeling'],
    types: ['gamedev'], image: redsecret, link: 'https://red-secret-escape-from-sverdlovsk.fandom.com/fr/wiki/Escape_from_Sverdlovsk' },
  
  { title: 'TARDIS', year: '2026',
    desc: 'A data-science capstone: cleaning a chaotic CSV (broken types, irregular regexes, duplicates), exploring the cleaned set, and training competing regression models — linear, random forest, gradient boosting — compared on R², MAE and RMSE. Wrapped in a Streamlit dashboard.',
    tags: ['Data Science','Jupyter','Scikit-learn','Streamlit','Random Forest'],
    types: ['dataia'], image: tardis, link: 'https://github.com/raph-bl/TARDIS' },

  { title: 'Trellux', year: '2024',
    desc: 'A Trello-inspired board app built under a constrained stack — MySQL2, Express.js, Dockerised — focused on REST routing principles, auth, and clean separation of concerns.',
    tags: ['Docker','Node.js','React','Express','MySQL2','REST API'],
    types: ['web'], image: trellux, link: 'https://github.com/raph-bl/Trellux' },

  { title: 'Graphy', year: '2026',
    desc: 'Interactive graph-based IDE that visualizes codebases as connected nodes (functions, classes, modules) with AI-powered code explanation, refactoring, and generation. Built and shipped in 48 hours — won the hackathon.',
    tags: ['Electron','React','Typescript', 'AST', 'TanStack'],
    badges: ['🥇 Hackathon Winner'],
    types: ['desktop'], image: graphy, imageZoom: 1.004, link: 'https://github.com/raph-bl/Graphy' },
        
  { title: 'Alice In Wonderland', year: '2026',
    desc: 'Academic NLP project to analyze Project Gutenberg books — topic modeling, similarity, named entities, summarization & clustering.',
    tags: ['Python','NLP','Maching Learning', 'Topic Modelling'],
    types: ['dataia'], image: alice, link: 'https://github.com/raph-bl/Alice-In-Wonderland' },

  { title: 'BytePilote', year: '2023',
    desc: 'A computer-performance monitor mixing an Electron front-end with a native C core for low-level metrics. Inspired by NZXT CAM — my first attempt at marrying the system layer with a comfortable UI.',
    tags: ['C','ElectronJS','TypeScript'],
    types: ['low-level','desktop'], image: bytepilote, link: 'https://github.com/raph-bl/BytePilote' },
      
  { title: 'Geotrade.fr', year: '2023',
      desc: 'A showcase website for GEOTRADE SARL in the south of France — full rebuild on React + TypeScript with an Express backend. The polished v2 is on its way.',
      tags: ['React','TypeScript','Node.js','Express'],
      types: ['web'], image: geotrade, link: 'http://www.geotrade.fr' },
    
  { title: "Anna's Portfolio", year: '2026',
    desc: "My best friend Anna is a designer — she handed me the design and I coded her portfolio. A small commission, a fun collaboration, a reminder that good design deserves careful implementation.",
    tags: ['Node.js','Web'],
    types: ['web'], image: anna, link: 'https://anna-s-website.vercel.app' },
  
  { title: 'My_radar', year: '2024',
    desc: 'Air-traffic simulation in C with CSFML — aircraft moving between waypoints, control towers monitoring approaches, the whole thing configurable through script files.',
    tags: ['C','CSFML','Simulation'],
    types: ['low-level'], image: radar, link: 'https://github.com/raph-bl/Epitech-Public-Projects/tree/master/my_radar' },

  { title: 'Eliza', year: '2026',
    desc: 'MédiRDV — Academic medical appointment assistant chatbot powered by a local LLM (phi4-mini via Ollama) with RAG on healthcare PDFs.',
    tags: ['React','Typescript','LLM', 'RAG', 'Ollama', 'Embeddings'],
    types: ['dataia'], image: eliza, link: 'https://github.com/raph-bl/Eliza' },
];

export default projects;
